import React from 'react'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'
import DrSamraKiran_Cv from '../../../assets/F_Social_science_Cv/Management Sciences/CV Dr. Samra Kiran.pdf'
import DrFazailaShad from '../../../assets/F_Social_science_Cv/Management Sciences/Dr. Fazaila Shad.pdf'
import MadihaJabeen_CV from '../../../assets/F_Social_science_Cv/Management Sciences/Madiha Jabeen CV updated.pdf'


  const Management_Sciences = () => {
    
  
  return (
    <>
    <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Management Sciences</h2>
        
        <p>Faculty of Management Sciences.</p>
      </div>

      <div className="row">

      <TeacherCard
      name='Dr. Samra Kiran '
      profile_name='Assistant Professor Department of (Manangement Sciences)'
      intro='Head of Department Management Sciences Shaheed Benazir Bhutto Women university, Peshawar.'
      email=': skirran_0647@yahoo.com'
      cv={DrSamraKiran_Cv}
      google='https://scholar.google.com/citations?user=GWiipcwAAAAJ&hl=en'
      linkedin=''/>
   
      <TeacherCard
      name='Dr. Fazaila Shad '
      profile_name=' Lecturer Deparment of (Manangement Sciences)'
      intro='Lecturer Department of Management Sciences Shaheed Benazir Bhutto Women university, Peshawar'
      email=': Fazailashad@sbbwu.edu.pk'
      cv={DrFazailaShad}
      google='https://www.google.com/'
      linkedin=''/>
   
      <TeacherCard
      name='Dr. Madiha Jabeen'
      profile_name='Lecturer Deparment of (Manangement Sciences)'
      intro='Lecturer Department of Management Sciences Shaheed Benazir Bhutto Women university, Peshawar'
      email=': madiha_jabeen@hotmail.com  '
      cv={MadihaJabeen_CV}
      google='https://www.google.com/'
      linkedin=''/>
   
      
   
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>



      <Footer/>
    </>
  )
}

export default  Management_Sciences
